import React, { useEffect } from "react";
import "../styles/Notification.css";

interface NotificationProps {
  message: string;
  onClose: () => void;
}

const Notification: React.FC<NotificationProps> = ({ message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 1500); // auto-close after 1.5 sec
    return () => clearTimeout(timer);
  }, [onClose]);

  return <div className="notification">{message}</div>;
};

export default Notification;
